/**
 * データ調整オプション導線の位置決め（snippets/data-adjustment-entry.liquid）
 *
 * Cloudlift（Live Product Options）が描画する「入稿方法の選択肢」の直下へ、
 * テーマ側で描画した .daj-entry を移動する。Cloudlift はクライアント描画で、
 * 「データで作る／テキストのみで作る」の切り替えのたびに描画し直すため、
 * MutationObserver で監視し続け、消えたら差し込み直す。
 *
 *   新型 LPO: .dp-wrap（① データの準備方法）内、.dp-more の直前（無ければ末尾）
 *   旧型 LPO: .cl-po--option[data-option="入稿形式を選ぶ"] の直後
 *
 * どちらの差し込み先も無い状態では hidden のまま何も表示しない。
 * 設計は design-maker-auto-upload.js（同じく Cloudlift 領域を監視）に合わせている。
 */
(function () {
  "use strict";

  var SELECTOR_NEW_WRAP = ".dp-wrap";
  var SELECTOR_NEW_TAIL = ".dp-more";
  var SELECTOR_OLD_ANCHOR = '.cl-po--option[data-option="入稿形式を選ぶ"]';
  var SELECTOR_SCOPE = "form[action*='/cart/add'], .product-single__form, .product-single__meta";

  function initialize(entry) {
    if (!entry || entry.dataset.dajEntryReady === "true") return;
    entry.dataset.dajEntryReady = "true";

    var scope = entry.closest(SELECTOR_SCOPE) || document.body;
    var scheduled = false;
    var frameId = 0;

    function findAnchor() {
      var wrap = scope.querySelector(SELECTOR_NEW_WRAP);
      if (wrap) {
        var tail = wrap.querySelector(SELECTOR_NEW_TAIL);
        return { parent: wrap, before: tail, kind: "new" };
      }
      var old = scope.querySelector(SELECTOR_OLD_ANCHOR);
      if (old && old.parentNode) {
        return { parent: old.parentNode, before: old.nextSibling, kind: "old" };
      }
      return null;
    }

    function isPlaced(anchor) {
      if (!entry.isConnected || entry.parentNode !== anchor.parent) return false;
      // 直前の要素が変わっていなければ置き直さない（監視ループを避ける）
      var expectedPrev = anchor.before ? anchor.before.previousSibling : anchor.parent.lastChild;
      if (anchor.before === entry) return true;
      return expectedPrev === entry;
    }

    function place() {
      scheduled = false;
      frameId = 0;
      var anchor = findAnchor();
      if (!anchor) {
        if (!entry.hidden) entry.hidden = true;
        return;
      }
      if (!isPlaced(anchor)) {
        anchor.parent.insertBefore(entry, anchor.before && anchor.before !== entry ? anchor.before : null);
      }
      if (entry.dataset.lpoType !== anchor.kind) entry.dataset.lpoType = anchor.kind;
      if (entry.hidden) entry.hidden = false;
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      frameId = window.requestAnimationFrame(place);
    }

    function isOnlyEntry(list) {
      if (!list || !list.length) return true;
      for (var i = 0; i < list.length; i++) if (list[i] !== entry) return false;
      return true;
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        // 自分自身の移動（追加・削除ノードが entry だけ）や entry 内部の変化は無視する
        if (m.target === entry || entry.contains(m.target)) continue;
        if (m.type === "childList" && isOnlyEntry(m.addedNodes) && isOnlyEntry(m.removedNodes)) continue;
        schedule();
        return;
      }
    });

    function connect() {
      observer.observe(scope, { childList: true, subtree: true });
      place();
    }
    connect();

    var link = entry.querySelector("[data-daj-entry-link]");
    if (link) {
      link.addEventListener("click", function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "data_adjustment_entry_click",
            product_handle: entry.dataset.productHandle || "",
            lpo_type: entry.dataset.lpoType || "",
          });
        } catch (error) {
          /* 計測は失敗しても遷移を止めない */
        }
      });
    }

    window.addEventListener("pagehide", function () {
      observer.disconnect();
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = 0;
      scheduled = false;
    });
    // BFCache から復元されたときは監視を張り直し、Cloudlift の再描画に追従できるようにする
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) connect();
    });
  }

  function boot() {
    var entries = document.querySelectorAll("[data-daj-entry]");
    for (var i = 0; i < entries.length; i++) initialize(entries[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
